import { AuthenticatedRequest, HTTPMethod, APIVersion, BasicRequest } from "../requests/request";
import { DeviceData } from "..";

export class API {
    /**
     * Use this method for authenticated users to sign up for an promotion
     * @returns {Promise<any>} The Promise contains an APIError if rejected
     * Error Types:
     * 401 MissingAuthorizationError
     * 401 SessionNotFoundError
     * 402 PaymentInfoMissingError
     * 400 InvalidParametersError
     * 403 NotAccessibleError: Already subscribed to a plan
     * 404 ResourceNotFound: Promotioncode not found or expired
     * 500 InternalServerError
     */
    public static applyPromotion(promotion_code: string, partner: string): Promise<any> {
        let apiRequest = new AuthenticatedRequest<any>('/promotion/sign_up', HTTPMethod.POST, APIVersion.v1_2, {}, {
            promotion_code,
            partner
        });

        return apiRequest.send().then((response) => {
            return response.data;
        });
    }
}


// WEBPACK FOOTER //
// ./src/api/src/endpoints/promotion.ts